<div class="w-full flex flex-col rounded-md border border-gray-200 dark:border-gray-800 p-4 gap-4">
    <div class="border-b border-gray-900/10 dark:border-white/10">
        <h2 class="text-lg font-medium">Advertising Objective</h2>
        <p class="mb-1 text-sm/6 text-gray-600 dark:text-gray-400">Select the advertising objective for your campaign.
        </p>
    </div>

    <ul role="list" class="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3">
        @for (objective of advertisingObjectives; track $index) {
        <li (click)="selectAdvertisingObjective(objective)"
            class="col-span-1 flex rounded-md shadow-xs dark:shadow-none">
            <div
                class="flex w-16 shrink-0 items-center justify-center rounded-l-md bg-pink-600 text-sm font-medium text-white dark:bg-pink-700">

                @switch (objective.api_value) {
                @case ('REACH') {
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-6">
                    <path
                        d="M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" />
                    <path d="M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14" />
                    <path d="M8 6v8" />
                </svg>
                }
                @case ('TRAFFIC') {
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-6">
                    <path
                        d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" />
                    <path d="m21.854 2.147-10.94 10.939" />
                </svg>
                }
                @case ('VIDEO_VIEWS') {
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-6">
                    <path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5" />
                    <rect x="2" y="6" width="14" height="12" rx="2" />
                </svg>
                }
                @case ('ENGAGEMENT') {
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-6">
                    <path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5" />
                    <rect x="2" y="6" width="14" height="12" rx="2" />
                </svg>
                }
                @case ('APP_PROMOTION') {
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-6">
                    <rect width="14" height="20" x="5" y="2" rx="2" ry="2" />
                    <path d="M12 18h.01" />
                </svg>
                }
                @case ('LEAD_GENERATION') {
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-6">
                    <path
                        d="M13.354 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14v6a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341l1.218-1.348" />
                    <path d="M16 6h6" />
                    <path d="M19 3v6" />
                </svg>
                }
                }

            </div>
            <div
                class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50">
                <div class="flex-1 truncate px-4 py-2 text-sm">
                    <a class="font-medium text-gray-900 hover:text-gray-600 dark:text-white dark:hover:text-gray-200">{{
                        objective.objective }}</a>
                    <p class="text-gray-500 dark:text-gray-400 capitalize">{{ objective.type }}</p>
                </div>
                <div class="shrink-0 pr-2">
                    <button type="button"
                        class="inline-flex size-8 items-center justify-center rounded-full text-gray-400 hover:text-gray-500 focus:outline-2 focus:outline-offset-2 focus:outline-primary dark:hover:text-white dark:focus:outline-white">
                        @if (createSparkCampaignService.selectedAdvertisingObjective()?.api_value ===
                        objective.api_value) {
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 text-accent">
                            <circle cx="12" cy="12" r="10" />
                            <path d="m9 12 2 2 4-4" />
                        </svg>
                        } @else {
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <circle cx="12" cy="12" r="10" />
                        </svg>
                        }
                    </button>
                </div>
            </div>
        </li>
        }
    </ul>

    @if (createSparkCampaignService.selectedAdvertisingObjective()) {
    @switch (createSparkCampaignService.selectedAdvertisingObjective()?.api_value) {
    @case ('REACH') {
    <div class="rounded-md bg-yellow-50 px-4 p-2 dark:bg-yellow-500/10 dark:outline dark:outline-yellow-500/15">
        <div class="flex">
            <div class="shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5 text-yellow-400 dark:text-yellow-300">
                    <path
                        d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                    <path d="M9 18h6" />
                    <path d="M10 22h4" />
                </svg>
            </div>
            <div class="ml-3">
                <h3 class="text-sm font-medium text-yellow-800 dark:text-yellow-100">Tips</h3>
                <div class="mt-1 text-sm text-yellow-700 dark:text-yellow-100/80">
                    <p><b class="font-semibold">Choose this objective to:</b> Tell more people about your
                        product, service, or company.</p>
                    <p><b class="font-semibold">Best For:</b> Brand Awareness</p>
                </div>
            </div>
        </div>
    </div>
    }
    @case ('TRAFFIC') {
    <div class="rounded-md bg-yellow-50 px-4 p-2 dark:bg-yellow-500/10 dark:outline dark:outline-yellow-500/15">
        <div class="flex">
            <div class="shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5 text-yellow-400 dark:text-yellow-300">
                    <path
                        d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                    <path d="M9 18h6" />
                    <path d="M10 22h4" />
                </svg>
            </div>
            <div class="ml-3">
                <h3 class="text-sm font-medium text-yellow-800 dark:text-yellow-100">Tips</h3>
                <div class="mt-1 text-sm text-yellow-700 dark:text-yellow-100/80">
                    <p><b class="font-semibold">Choose this objective to:</b> Send more people to your
                        website, app, or TikTok Shop.</p>
                    <p><b class="font-semibold">Best For:</b> Traffic & website views</p>
                </div>
            </div>
        </div>
    </div>
    }
    @case ('VIDEO_VIEWS') {
    <div class="rounded-md bg-yellow-50 px-4 p-2 dark:bg-yellow-500/10 dark:outline dark:outline-yellow-500/15">
        <div class="flex">
            <div class="shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5 text-yellow-400 dark:text-yellow-300">
                    <path
                        d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                    <path d="M9 18h6" />
                    <path d="M10 22h4" />
                </svg>
            </div>
            <div class="ml-3">
                <h3 class="text-sm font-medium text-yellow-800 dark:text-yellow-100">Tips</h3>
                <div class="mt-1 text-sm text-yellow-700 dark:text-yellow-100/80">
                    <p><b class="font-semibold">Choose this objective to:</b> Maximise the plays of your
                        video ads & drive consideration by showing your ads to users who are more actively
                        engaged.</p>
                    <p><b class="font-semibold">Best For:</b> Consideration & Focused view</p>
                </div>
            </div>
        </div>
    </div>
    }
    @case ('ENGAGEMENT') {
    <div class="rounded-md bg-yellow-50 px-4 p-2 dark:bg-yellow-500/10 dark:outline dark:outline-yellow-500/15">
        <div class="flex">
            <div class="shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5 text-yellow-400 dark:text-yellow-300">
                    <path
                        d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                    <path d="M9 18h6" />
                    <path d="M10 22h4" />
                </svg>
            </div>
            <div class="ml-3">
                <h3 class="text-sm font-medium text-yellow-800 dark:text-yellow-100">Tips</h3>
                <div class="mt-1 text-sm text-yellow-700 dark:text-yellow-100/80">
                    <p><b class="font-semibold">Choose this objective to:</b> Get more people to follow your
                        account, Visit your TikTok Profile or promote Live Stream.</p>
                    <p><b class="font-semibold">Best For:</b> Community Engagement & Follower Growth</p>
                </div>
            </div>
        </div>
    </div>
    }
    @case ('APP_PROMOTION') {
    <div class="rounded-md bg-yellow-50 px-4 p-2 dark:bg-yellow-500/10 dark:outline dark:outline-yellow-500/15">
        <div class="flex">
            <div class="shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5 text-yellow-400 dark:text-yellow-300">
                    <path
                        d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                    <path d="M9 18h6" />
                    <path d="M10 22h4" />
                </svg>
            </div>
            <div class="ml-3">
                <h3 class="text-sm font-medium text-yellow-800 dark:text-yellow-100">Tips</h3>
                <div class="mt-1 text-sm text-yellow-700 dark:text-yellow-100/80">
                    <p><b class="font-semibold">Choose this objective to:</b></p>
                    <ol>
                        <li>Optimize for people who install your app and take additional actions like
                            purchase or subscribe.</li>
                        <li>Get more people to take action on your app.</li>
                    </ol>
                    <p><b class="font-semibold">Best For:</b> App Downloads & User Engagement</p>
                </div>
            </div>
        </div>
    </div>
    }
    @case ('LEAD_GENERATION') {
    <div class="rounded-md bg-yellow-50 px-4 p-2 dark:bg-yellow-500/10 dark:outline dark:outline-yellow-500/15">
        <div class="flex">
            <div class="shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5 text-yellow-400 dark:text-yellow-300">
                    <path
                        d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                    <path d="M9 18h6" />
                    <path d="M10 22h4" />
                </svg>
            </div>
            <div class="ml-3">
                <h3 class="text-sm font-medium text-yellow-800 dark:text-yellow-100">Tips</h3>
                <div class="mt-1 text-sm text-yellow-700 dark:text-yellow-100/80">
                    <p><b class="font-semibold">Choose this objective to:</b></p>
                    <ol>
                        <li>Collect leads using instant forms on TikTok.</li>
                        <li>Collect leads, contact info, and registration on your website.</li>
                        <li>Start conversations on WhatsApp, Messenger, TikTok direct message, and more.
                        </li>
                    </ol>
                    <p><b class="font-semibold">Best For:</b> Find new customers & Qualify leads</p>
                </div>
            </div>
        </div>
    </div>
    }
    }
    }

</div>



